import "./App.css";
import "./css/weather-icons.min.css";

import WeatherContainer from "./container/WeatherContainer";

function App() {
  return (
    <div className="App">
      <WeatherContainer></WeatherContainer>
    </div>
  );
}

export default App;
